interface PaginationProps {
	page: number;
	pageCount: number;
	totalItems: number;
	pageSize: number;
	onPageChange: (page: number) => void;
}

export function Pagination({
	page,
	pageCount,
	totalItems,
	pageSize,
	onPageChange,
}: PaginationProps) {
	if (pageCount <= 1) return null;

	const start = (page - 1) * pageSize + 1;
	const end = Math.min(page * pageSize, totalItems);

	return (
		<div className="flex items-center justify-between gap-3 mt-3 pt-2 border-t border-base-content/10 text-[10px] font-mono text-base-content/50">
			<span className="tabular-nums">
				{start}–{end} of {totalItems}
			</span>
			<div className="flex items-center gap-1">
				<button
					type="button"
					onClick={() => onPageChange(page - 1)}
					disabled={page <= 1}
					className="px-2 py-1 rounded border border-base-content/10 hover:border-primary/40 hover:text-primary disabled:opacity-30 disabled:hover:border-base-content/10 disabled:hover:text-base-content/50 transition-colors"
				>
					← prev
				</button>
				<span className="px-1 text-base-content/70 tabular-nums">
					{page} / {pageCount}
				</span>
				<button
					type="button"
					onClick={() => onPageChange(page + 1)}
					disabled={page >= pageCount}
					className="px-2 py-1 rounded border border-base-content/10 hover:border-primary/40 hover:text-primary disabled:opacity-30 disabled:hover:border-base-content/10 disabled:hover:text-base-content/50 transition-colors"
				>
					next →
				</button>
			</div>
		</div>
	);
}
